<template>
    <div class="report-ces">
        <div class="top clearfix">
            <div class="title">
                <slot name="title">{{ $root.t('forms-report_component-general_assessment') }}</slot>
                <span class="total-answers">{{ grades.length }} {{ $root.t('forms-report_component-answers') }}</span>
            </div>
            <div v-if="hasAnswers">
                <div class="ces-result">
                    <svg viewBox="0 0 36 36" class="circular-chart">
                        <path class="circle-bg" d="M18 2.0845
                        a 15.9155 15.9155 0 0 1 0 31.831
                        a 15.9155 15.9155 0 0 1 0 -31.831" />
                        <path class="circle" :stroke="circleColor" :stroke-dasharray="`${percentage}, 100`" d="M18 2.0845
                        a 15.9155 15.9155 0 0 1 0 31.831
                        a 15.9155 15.9155 0 0 1 0 -31.831" />
                        <text x="18" y="20.35" class="percentage">{{ cesScore }}</text>
                    </svg>
                    <div class="title">{{ t('ces_score') }}</div>
                </div>
            </div>
        </div>
        <div class="distribuition" v-if="hasAnswers">
            <div class="distribuition-row" v-for="(i) in 7" :key="i">
                <span class="label" for="">{{ gradeLabels[i - 1] }}</span>
                <div class="bar">
                    <div
                        class="inside-bar"
                        v-bind:style="{
                            width:
                                gradesNumberToPercent(distributedGrades[i]) +
                                '%',
                        }"
                    ></div>
                </div>
                <div class="percent">
                    {{ round(gradesNumberToPercent(distributedGrades[i])) }}%
                </div>
            </div>
        </div>
        <div class="no-answers" v-if="!hasAnswers">
            {{ $root.t('forms-report_component-no_answers') }}
        </div>
    </div>
</template>
<script>
import MathHelper from "../../helpers/Math";
export default {
    props: {
        useGrade: {
            type: Boolean,
            default: false,
        },
        answers: Array,
    },
    data() {
        return {};
    },
    computed: {
        percentage() {
            return ((this.cesScore)  / 7) * 100;
        },
        gradeLabels() {
            return [
                this.$root.t('forms-report_component-ces_label_1'),
                this.$root.t('forms-report_component-ces_label_2'),
                this.$root.t('forms-report_component-ces_label_3'),
                this.$root.t('forms-report_component-ces_label_4'),
                this.$root.t('forms-report_component-ces_label_5'),
                this.$root.t('forms-report_component-ces_label_6'),
                this.$root.t('forms-report_component-ces_label_7'),
            ];
        },
        circleColor() {
            if (this.cesScore >= 1 && this.cesScore <= 3) {
                return "#00542E";
            } else if (this.cesScore >= 4 && this.cesScore < 5) {
                return "#FFCA02";
            } else if (this.cesScore >= 5 && this.cesScore <= 7) {
                return "#FF7B7B";
            }
            return "red";
        },
        grades() {
            let grades = [];
            for (let a in this.answers) {
                let answer = this.answers[a];
                if (this.useGrade) {
                    grades.push(answer.grade);
                } else {
                    grades.push(answer.valueNumber);
                }
            }
            return grades;
        },
        hasAnswers: function () {
            return this.grades.length > 0 ? true : false;
        },
        distributedGrades: function () {
            let distributedGrades = [0, 0, 0, 0, 0, 0, 0, 0];
            for (var i = 0; i < this.grades.length ; i++) {
                let grade = this.round(this.grades[i]);
                distributedGrades[grade]++;
            }
            return distributedGrades;
        },
        cesScore() {
            const totalResponses = this.grades.length;
            const extremelyHard = this.distributedGrades[1] * 7;
            const veryHard = this.distributedGrades[2] * 6;
            const hard = this.distributedGrades[3] * 5;
            const acceptable = this.distributedGrades[4] * 4;
            const easy = this.distributedGrades[5] * 3;
            const veryEasy = this.distributedGrades[6] * 2;
            const extremelyEasy = this.distributedGrades[7];
            const cesScore = (extremelyEasy + veryEasy + easy + acceptable + hard + veryHard + extremelyHard) / totalResponses;
            return cesScore.toFixed(2);
        }
    },
    methods: {
        gradesNumberToPercent: function (number) {
            return (number / this.grades.length) * 100;
        },
        round: MathHelper.round,
    },
};
</script>
